export const date = {
    format: {
        display: 'dd/MM/yyyy',
        human: 'dd/MM/yyyy HH:mm:ss',
        isoQuery: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSZZ',
    },
};

export const time = {
    format: {
        display: 'HH:mm:ss',
        human: 'HH:mm',
    }
};

export const monthsList: { value: number, label: string }[] = [
    {value: 1, label: 'Janvier'},
    {value: 2, label: 'Février'},
    {value: 3, label: 'Mars'},
    {value: 4, label: 'Avril'},
    {value: 5, label: 'Mai'},
    {value: 6, label: 'Juin'},
    {value: 7, label: 'Juillet'},
    {value: 8, label: 'Août'},
    {value: 9, label: 'Septembre'},
    {value: 10, label: 'Octobre'},
    {value: 11, label: 'Novembre'},
    {value: 12, label: 'Décembre'}
];

